import { ReactNode, useState } from 'react'
import { Sidebar, SIDEBAR_WIDTH, SIDEBAR_COLLAPSED_WIDTH } from './Sidebar'
import { ClientTopBar } from './ClientTopBar'
import { useAuth } from '@/contexts/AuthContext'
import { ClientPreviewProvider, useClientPreview } from '@/contexts/ClientPreviewContext'

interface AppLayoutProps {
  children: ReactNode
}

export function AppLayout({ children }: AppLayoutProps) {
  return (
    <ClientPreviewProvider>
      <AppLayoutFrame>{children}</AppLayoutFrame>
    </ClientPreviewProvider>
  )
}

function AppLayoutFrame({ children }: AppLayoutProps) {
  const [sidebarOpen, setSidebarOpen] = useState(true)
  const { user } = useAuth()
  const { clientPreview } = useClientPreview()

  // Portail client : un seul écran utile (Projets), donc bandeau en haut plutôt que sidebar.
  // Même cadre pour un admin en « Vue client ». La page reste au même endroit de l'arbre
  // pour ne pas être remontée (et perdre son état) lors de la bascule.
  const showClientTopBar = user?.role === 'client' || clientPreview

  return (
    <div className="min-h-screen bg-brand-canvas">
      {showClientTopBar ? (
        <ClientTopBar />
      ) : (
        <Sidebar
          isOpen={sidebarOpen}
          onToggle={() => setSidebarOpen((o) => !o)}
        />
      )}
      <main
        className={
          showClientTopBar
            ? 'flex min-h-[calc(100vh-57px)] flex-col'
            : 'min-h-screen flex flex-col transition-[margin-left] duration-200 ease-in-out'
        }
        style={
          showClientTopBar
            ? undefined
            : { marginLeft: sidebarOpen ? SIDEBAR_WIDTH : SIDEBAR_COLLAPSED_WIDTH }
        }
      >
        {children}
      </main>
    </div>
  )
}
